import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_xc9275qqzm: FaireCollectionEntity = {
  token: "pbc_xc9275qqzm",
  type: "collection",
  name: "garden",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a615049a64164680469a57ae64d0cc05831500fe694b9b50f5a480ec131b63ca.jpeg",
  itemCount: 26,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.929Z",
    importedBy: "entity-db-import-collections",
  },
};
